// extracted by mini-css-extract-plugin
export default {"RecoveryCard__form":"KS1d6bgnk4"};